import styled, { css } from 'styled-components';

const Container = styled.div`
  ${({ isDesktop }) =>
    !isDesktop
      ? css`
          width: 100%;
          position: fixed;
          z-index: ${({ theme }) => theme.constants.zIndex.defaultToast};
          align-items: center;
          transition: 0.5s;
          bottom: ${({ show, theme }) =>
            show ? theme.commons.toast.bottom : '-100%'};
        `
      : css`
          width: 25%;
          top: 3%;
          right: 3%;
          position: fixed;
          z-index: ${({ theme }) => theme.constants.zIndex.defaultToast};
          border-radius: 5px;
          align-items: center;
          transition: 0.5s;
          display: ${({ show }) => (show ? 'auto' : 'none')};
        `}
`;

export default Container;
